import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const TAGS = [
  { id: 'winner', emoji: '🏸', label: '致勝球', color: '#34d399' },
  { id: 'error', emoji: '😬', label: '主動失誤', color: '#fb7185' },
  { id: 'serve_fault', emoji: '⚡', label: '發球失誤', color: '#f59e0b' },
  { id: 'receive_fault', emoji: '🫳', label: '接發失誤', color: '#a78bfa' },
  { id: 'out', emoji: '↗️', label: '出界', color: '#60a5fa' },
  { id: 'net', emoji: '🥅', label: '下網', color: '#f97316' },
];

const PointTagSheet = ({ open, scorerTeam, scorerName, onTag, onSkip }) => (
  <AnimatePresence>
    {open && (
      <>
        <motion.div
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          className="fixed inset-0 z-[180]" onClick={onSkip} />

        <motion.div
          initial={{ y: '100%' }} animate={{ y: 0 }} exit={{ y: '100%' }}
          transition={{ type: 'spring', damping: 28, stiffness: 320 }}
          className="fixed bottom-0 left-0 right-0 z-[190] bg-[#0d1a2e] border-t border-white/10 rounded-t-3xl px-4 pt-4 pb-6 safe-bottom"
          style={{ paddingBottom: 'max(1.5rem, env(safe-area-inset-bottom))' }}>

          <div className="w-10 h-1 rounded-full bg-white/20 mx-auto mb-4" />

          <div className="flex items-center justify-between mb-4">
            <div>
              <p className="text-[10px] font-black text-white/40 uppercase tracking-widest mb-0.5">標記本分</p>
              <p className="text-sm font-black text-white">
                <span className="text-emerald-400">{scorerName}</span> 得分
              </p>
            </div>
            <button onClick={onSkip}
              className="text-xs font-black text-white/30 hover:text-white/60 transition-colors px-3 py-1.5 rounded-lg hover:bg-white/5">
              跳過
            </button>
          </div>

          <div className="grid grid-cols-3 gap-2.5">
            {TAGS.map(tag => (
              <button key={tag.id} onClick={() => onTag(tag.id)}
                className="flex flex-col items-center gap-2 py-3.5 rounded-2xl border transition-all active:scale-95"
                style={{ backgroundColor: `${tag.color}15`, borderColor: `${tag.color}35` }}>
                <span className="text-2xl">{tag.emoji}</span>
                <span className="text-xs font-black" style={{ color: tag.color }}>{tag.label}</span>
              </button>
            ))}
          </div>
        </motion.div>
      </>
    )}
  </AnimatePresence>
);

export { TAGS };
export default PointTagSheet;